import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { safeDayjs } from "@/helpers/dateHelper"
import dayjs from "dayjs"
import { IFlexMarketSubscription } from "./flexMarketSubscription.types"
import { FlexMarketSubscription } from "./flexMarketSubscription"

export interface IFlexMarketSubscriptionRaw {
  onboarded_at: string
  meter_point?: {
    identifier: string
  } | null
  offboarded_at?: string | null
}

export const FlexMarketSubscriptionParser: IParser<
  IFlexMarketSubscription,
  IFlexMarketSubscriptionRaw
> = {
  toDomain: (data: IFlexMarketSubscriptionRaw): IFlexMarketSubscription => {
    try {
      if (!data.meter_point) {
        throw new Error("Meter point not found")
      }

      return new FlexMarketSubscription(
        dayjs(data.onboarded_at),
        data.meter_point.identifier,
        safeDayjs(data.offboarded_at),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
